import React from "react";
import Menu from "./Menu";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Divider,
  Stack
} from "@mui/material";
import {
  Phone,
  Email,
  WhatsApp,
  HelpOutline,
  SupportAgent
} from "@mui/icons-material";

function Help() {
  return (
    <Box display="flex" minHeight="100vh" bgcolor="#f4f6f8">
      <Menu />

      <Box flex={1} p={4} className="content-wrapper">
        {/* HEADER */}
        <Card
          sx={{
            mb: 4,
            borderRadius: 4,
            background: "linear-gradient(135deg, #1976d2, #42a5f5)",
            color: "#fff",
          }}
        >
          <CardContent>
            <Stack direction="row" spacing={2} alignItems="center">
              <SupportAgent sx={{ fontSize: 50 }} />
              <Box>
                <Typography fontSize={28} fontWeight={800}>
                  Help & Support
                </Typography>
                <Typography fontSize={14} sx={{ opacity: 0.9 }}>
                  We are here to help you 24×7 with everything you need
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>

        {/* SUPPORT CARDS */}
        <Grid className="row" spacing={3} mb={4}>
          {[
            {
              icon: <Phone />,
              title: "Call Support",
              desc: "Speak directly with our support team",
              action: "+91 XXXXX 43210",
              color: "#1976d2",
              variant: "contained",
            },
            {
              icon: <Email />,
              title: "Email Support",
              desc: "Response within 24 working hours",
              action: "support@ttx.com",
              color: "#6a1b9a",
              variant: "outlined",
            },
            {
              icon: <WhatsApp />,
              title: "WhatsApp Chat",
              desc: "Quick help on WhatsApp",
              action: "Start Chat",
              color: "#2e7d32",
              variant: "contained",
            },
          ].map((item, index) => (
            <Grid className="col-sm-4" item xs={12} md={4} key={index}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 4,
                  transition: "0.3s",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  "&:hover": {
                    transform: "translateY(-6px)",
                    boxShadow: "0 20px 40px rgba(0,0,0,0.12)",
                  },
                }}
              >
                <CardContent>
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "50%",
                      bgcolor: item.color,
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography fontWeight={700} fontSize={18}>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary" mt={0.5}>
                    {item.desc}
                  </Typography>

                  <Button
                    fullWidth
                    variant={item.variant}
                    sx={{ mt: 2 }}
                  >
                    {item.action}
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

     
      </Box>
    </Box>
  );
}

export default Help;
